import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";
import GenericChartComponent from "../GenericChartComponent";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

// Tooltip do High & Low do Silverlight (FML.HighLow) — séries "H" e "L".
// ≠ HighLowTooltip (HHV/LLV).
class HighLowMaTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      origin: originProp,
      options,
      appearance,
    } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const { currentItem } = moreProps;

    if (!isDefined(currentItem)) return null;

    const data = yAccessor(currentItem);
    if (!isDefined(data)) return null;

    const { high, low } = data;
    const mHigh = options.mHigh || 20;
    const mLow = options.mLow || 20;

    const highFormatted = isDefined(high) ? displayFormat(high) : "n/a";
    const lowFormatted = isDefined(low) ? displayFormat(low) : "n/a";

    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const strokeHighColor = appearance?.strokeHigh?.color || "#FFFF00";
    const strokeLowColor = appearance?.strokeLow?.color || "#FF0000";

    return (
      <g
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-high-low-ma"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill="#FFFFFF">
            {`High & Low (${mHigh},${mLow}): `}
          </ToolTipTSpanLabel>
          <tspan fill={strokeHighColor}>{`H: ${highFormatted}`}</tspan>
          <ToolTipTSpanLabel fill="#FFFFFF">{", "}</ToolTipTSpanLabel>
          <tspan fill={strokeLowColor}>{`L: ${lowFormatted}`}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

HighLowMaTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  options: PropTypes.shape({
    mHigh: PropTypes.number,
    mLow: PropTypes.number,
  }).isRequired,
  appearance: PropTypes.shape({
    strokeHigh: PropTypes.shape({
      color: PropTypes.string,
    }),
    strokeLow: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
};

HighLowMaTooltip.defaultProps = {
  displayFormat: format(".2f"),
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default HighLowMaTooltip;
